import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {EnumValidValueItemModel} from '../../models/enum/enum-valid-value-item.model';
import {HttpClient} from '@angular/common/http';
import {DialogService} from '../../services/dialog.service';
import {TdoTableV2Component} from '../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import {TdoTableSelectionEvent} from '../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import {TdoTableRowModel} from '../../tdo-controls/common/tdo-table-v2/models/tdo-table-row.model';
import {StaticDataService} from '../../services/static-data.service';
import {EnumValidValueModel} from '../../models/enum/enum-valid-value.model';
import {DxDataGridComponent} from 'devextreme-angular';

@Component({
    selector: 'app-edit-enum-dialog',
    templateUrl: './edit-enum-dialog.component.html',
    styleUrls: ['./edit-enum-dialog.component.scss']
})
export class EditEnumDialogComponent implements OnInit {
    @ViewChild('table') table: TdoTableV2Component;
    @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;
    selectedValidValueItem: EnumValidValueItemModel;
    private _selectedValidValue: EnumValidValueModel;
    validValue_Name: string = 'Name ?';
    validValue_isSystem: boolean = false;
    ldata: EnumValidValueItemModel[]=[];

    constructor(private dialogRef: MatDialogRef<EditEnumDialogComponent>,
                private http: HttpClient,
                private dialogService: DialogService,
                private staticDataService: StaticDataService,
                @Inject(MAT_DIALOG_DATA) public data: EnumValidValueItemModel[]) {

        this.onSetValueItemDisplayValue = this.onSetValueItemDisplayValue.bind(this);
        this.onSetValueItemSValue = this.onSetValueItemSValue.bind(this);
        this.onSetValuexauditDeleted = this.onSetValuexauditDeleted.bind(this);

        this.onReorder = this.onReorder.bind(this);
    }


    selectedItemKeys: string[] = [];

    ngOnInit(): void {
    //   get validvalue record : name and isSystem



        const ValidValueId = this.data[0].ValidValueId;


        this.http.get<any>(`api/valid-value-record/${ValidValueId}`).subscribe((res) => {
            // .get<any>(`/api/feeSchedule/getAllSchedulesByOrganization/${OrganizationID}`);
            this.validValue_Name = res.ValidValueName;
            this.validValue_isSystem = res.isSystem;

            // load full list here
            this.http.get<any>(`api/valid-values-full-list-by-id/${ValidValueId}`).subscribe((resd) => {

            this.ldata=resd;
            console.log('valid values :  ', this.ldata);

          });

        });




    }

    // zoli V2


    onSetValuexauditDeleted(newData, value, currentRowData) {
    // console.log('cell update:', newData,"value:" ,value,"row:", currentRowData);

        let  r = this.ldata.find(f => f.ValidValueItemId  ===  currentRowData.ValidValueItemId);

        r.xauditDeleted = value;

        this.staticDataService.saveValidValueItem(r, false).subscribe(res => {

          console.log("save", res);
        });

    }
    onSetValueItemSValue(newData, value, currentRowData) {
    // console.log('cell update:', newData,"value:" ,value,"row:", currentRowData);

        let r = this.ldata.find(f => f.ValidValueItemId  ===  currentRowData.ValidValueItemId);

        r.ItemSValue = value;

        this.staticDataService.saveValidValueItem(r, false).subscribe(res => {

          console.log("save", res);
        });
    }
    onSetValueItemDisplayValue(newData, value, currentRowData) {
        // console.log('cell update:', newData,"value:" ,value,"row:", currentRowData);

        let r = this.ldata.find(f => f.ValidValueItemId  ===  currentRowData.ValidValueItemId)
        r.ItemDisplayValue = value;

        this.staticDataService.saveValidValueItem(r, false).subscribe(res => {

          console.log("save", res);
        });
    }

    onSelectionChanged( selectedRowKeys ) {
        this.selectedItemKeys = selectedRowKeys;
    }


    addRecord() {
        let a : EnumValidValueItemModel = { ValidValueItemId: '', ValidValueId :  this.ldata[0].ValidValueId, ItemOrder: this.ldata.length, ItemDisplayValue: 'New...',
            ItemSValue: '' , xauditDeleted: false, isSystem : false, ItemName: '',
            ChildValidValue: null, ChildValidValueId: '', ColorSchemeId: '', IconIDSVG: '', IconSet: '', isSelected: false, isPrimary: false,
            xauditCreatedBy: '', xauditCreatedOn: new Date(), xauditModifiedBy: '', xauditModifiedOn: new Date(), xauditTableRowID: ''
        };




      this.staticDataService.saveValidValueItem(a, true).subscribe(res => {

        this.ldata.push(res);
        //console.log("save", res);
      });


    }

    onReorder(e) {
        const visibleRows = e.component.getVisibleRows();
        const toIndex = this.ldata.findIndex((item) => item.ValidValueItemId === visibleRows[e.toIndex].data.ValidValueItemId);
        const fromIndex = this.ldata.findIndex((item) => item.ValidValueItemId === e.itemData.ValidValueItemId);

        this.ldata.splice(fromIndex, 1);
        this.ldata.splice(toIndex, 0, e.itemData);



        for (let i = 0; i < this.ldata.length; i++) {
            this.ldata[i].ItemOrder = i;

            this.staticDataService.saveValidValueItem(this.ldata[i], false).subscribe(res => {

              //console.log("save order ", i);
            });



        }

        console.log(this.ldata);

    }

    onClose() {

        this.dialogRef.close(this.ldata);
    }
    onCancel() {
        this.dialogRef.close();

    }


    // end V2

}
